import React from 'react'
import './Image.css'

function Image(props) {
  if (props.url === undefined || props.url === null) {
    return <div className="div-box-img" />
  }

  return (
    <div className="div-box-img">
      <img
        className={`div-img ${props.right ? 'pull-right' : ''}`}
        src={props.url}
        alt="new"
      />
    </div>
  )
}

export default Image
